export function normalizeBookingPath(value: string): string {
  const withoutQuery = value.trim().split(/[?#]/, 1)[0] ?? "";
  const withLeadingSlash = withoutQuery.startsWith("/") ? withoutQuery : `/${withoutQuery}`;
  const collapsed = withLeadingSlash.replace(/\/{2,}/g, "/").replace(/\/+$/, "");
  return collapsed.length === 0 || collapsed === "/" ? "/book" : collapsed;
}

export function shouldRenderBookingPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/{2,}/g, "/").replace(/\/+$/, "");
  return normalized.length > 0 && normalized !== "/";
}

export function clinicSlugFromBookingPath(pathname: string): string | undefined {
  return /^\/book\/([a-z0-9]+(?:-[a-z0-9]+)*)\/?$/.exec(pathname)?.[1];
}

/**
 * The demo app serves its one clinic at any configured booking path, so only "/" is the entry
 * page there. A deployed patient app serves many clinics, and a path without a clinic slug
 * (including "/book" and a widget loaded without data-clinic-slug) cannot name one.
 */
export function rendersPatientEntry(pathname: string, demoEnabled: boolean): boolean {
  return demoEnabled
    ? !shouldRenderBookingPath(pathname)
    : clinicSlugFromBookingPath(pathname) === undefined;
}

export function scheduledIntakeTokenFromPath(pathname: string): string | null {
  const match = /^\/intake\/([A-Za-z0-9_-]{24,128})$/.exec(pathname);
  return match?.[1] ?? null;
}

export function isScheduledIntakePath(pathname: string): boolean {
  return pathname === "/intake" || pathname.startsWith("/intake/");
}

export function canonicalizeBookingLocation(configuredPath: string): void {
  const canonicalPath = normalizeBookingPath(configuredPath);
  const currentPath = normalizeBookingPath(window.location.pathname);
  if (currentPath === canonicalPath && window.location.pathname === canonicalPath) return;
  window.history.replaceState(
    window.history.state,
    "",
    `${canonicalPath}${window.location.search}${window.location.hash}`,
  );
}
